import { create } from 'zustand';
import type { ThemeMode } from './theme-tokens';

// Bảng màu, font và thang chữ nằm ở `theme-tokens.ts` (thuần, có test tương phản). File này chỉ giữ LỰA
// CHỌN sáng/tối của người dùng.
export { FONT_FAMILY, SERIES_COLORS, buildAntdTheme, type ThemeMode } from './theme-tokens';

export type ThemePreference = ThemeMode | 'system';

const STORAGE_KEY = 'halo-theme';

function readPreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}

function systemMode(): ThemeMode {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

interface ThemeState {
  preference: ThemePreference;
  mode: ThemeMode;
  toggle: () => void;
  syncWithSystem: () => void;
}

/** Lựa chọn sáng/tối là tuỳ chọn HIỂN THỊ của từng máy nên để trong localStorage. */
export const useThemeStore = create<ThemeState>((set, get) => {
  const preference = readPreference();
  return {
    preference,
    mode: preference === 'system' ? systemMode() : preference,
    toggle() {
      const mode: ThemeMode = get().mode === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(STORAGE_KEY, mode);
      } catch {
        /* chế độ riêng tư: bỏ qua, chỉ không nhớ được lựa chọn */
      }
      set({ preference: mode, mode });
    },
    syncWithSystem() {
      if (get().preference === 'system') set({ mode: systemMode() });
    },
  };
});
